export default __webpack_public_path__ + "static/media/starFill.cab8a159.svg";